import { format, parseISO } from 'date-fns';

export default date => format(new Date(date), 'd MMM yyyy, H:mm');

export const formatDateSimple = date =>
  date ? format(parseISO(date), 'dd.MM.yyyy') : null;
